import { createStore } from 'vuex'

export default createStore({
  state: {
    hactive: "realtime",
    isShow: false
  },
  getters: {
  },
  mutations: {
    UpActive(state, active) {
      state.hactive = active
    },
    // 展示loading的方法
    showLoading(state) {
      state.isShow = true
    },
    // 隐藏loading的方法
    hideLoading(state) {
      state.isShow = false
    },
  },
  actions: {
  },
  modules: {
  }
})
